import {IInstrument} from './IInstrument';
import {Container, Matrix, RenderTexture, Sprite} from 'pixi.js';
import {DrawColor} from '../draw_menu/instument_top_block/color_picker/DrawColor';
import {StaticData} from '../../../data/StaticData';
import {HotkeysController} from '../../../controllers/HotkeysController';
import {TextCursor} from './instrument_text/TextCursor';
import {PixiApplicationController} from '../../../controllers/PixiApplicationController';
import {DrawHolderEvent} from '../draw_menu/events/DrawHolderEvent';

export class InstrumentText implements IInstrument
{
    private cardRender: Sprite | undefined;
    private onKeyDownBindThis: (e: KeyboardEvent) => void;
    private onKeyUpBindThis: (e: KeyboardEvent) => void;
    private escaping: boolean = false;

    constructor(private card: Sprite, private textCursor: TextCursor, private textCursorContainer: Container) {
        this.onKeyDownBindThis = this.onKeyDown.bind(this);
        this.onKeyUpBindThis = this.onKeyUp.bind(this);
    }

    setRender(value: Sprite): void {
        this.cardRender = value;
    };

    setSize(value: number) {
        this.textCursor.setSize(value);
    }

    setDrawColor(value: DrawColor) {
        this.textCursor.setDrawColor(value);
    }

    start(): void {
        this.card.interactive = true;
        HotkeysController.paused = true;
        document.addEventListener('keydown', this.onKeyDownBindThis);
        document.addEventListener('keyup', this.onKeyUpBindThis);
        this.resetCursor();
        this.textCursor.startBlink();
    };

    stop(): void {
        this.card.interactive = false;
        HotkeysController.paused = false;
        document.removeEventListener('keydown', this.onKeyDownBindThis);
        document.removeEventListener('keyup', this.onKeyUpBindThis);
        this.textCursor.stopBlink();
        this.escaping || this.drawText();
        this.escaping = false;
    };

    onKeyDown(keyboardEvent: KeyboardEvent): void {
        keyboardEvent.preventDefault();
        console.log(keyboardEvent.code, keyboardEvent.key);
        let keycode: string = keyboardEvent.code;
        let key: string = keyboardEvent.key;
        switch (keycode) {
            case 'Backspace':
                this.textCursor.removeLastChar();
                break;
            case 'Enter':
            case 'NumpadEnter':
                dispatchEvent(new MessageEvent(DrawHolderEvent.TEXT_DONE, {data: null}));
                break;
            default:
                if (StaticData.charsAndNumbers.split('').includes(key)) {
                    this.textCursor.addChar(key);
                }
        }

    }

    onKeyUp(keyboardEvent: KeyboardEvent): void {
        keyboardEvent.preventDefault();
        keyboardEvent.stopImmediatePropagation();
        keyboardEvent.stopPropagation();
        console.log(keyboardEvent.code, keyboardEvent.key);
        let keycode: string = keyboardEvent.code;
        let key: string = keyboardEvent.key;
        switch (keycode) {
            case 'Escape':
                this.escaping = true;
                this.resetCursor();
                dispatchEvent(new MessageEvent(DrawHolderEvent.TEXT_DONE, {data: null}));
                break;
        }
    }

    getCursor(): Sprite {
        return this.textCursor;
    }

    drawText(): void {
        this.textCursor.setBorderVisible(false);
        console.log("nb4");
        dispatchEvent(new MessageEvent(DrawHolderEvent.NEED_BACKUP));
        let transform: Matrix = new Matrix();
        transform.tx = Math.floor(this.card.width / 2);
        transform.ty = Math.floor(this.card.height / 2);
        PixiApplicationController.app.renderer.render(this.textCursor, {
            renderTexture: this.cardRender!.texture as RenderTexture,
            transform,
            clear: false
        });
        this.resetCursor();
    }

    private resetCursor(): void {
        this.textCursor.position.set(0, 0);
        this.textCursor.clear();
        this.textCursor.setBorderVisible();
    }
}
